/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LayoutConfigDataDTO } from './LayoutConfigDataDTO';
import {
    LayoutConfigDataDTOFromJSON,
    LayoutConfigDataDTOFromJSONTyped,
    LayoutConfigDataDTOToJSON,
} from './LayoutConfigDataDTO';

/**
 * 
 * @export
 * @interface LayoutSettingsDTO
 */
export interface LayoutSettingsDTO {
    /**
     * 
     * @type {LayoutConfigDataDTO}
     * @memberof LayoutSettingsDTO
     */
    config: LayoutConfigDataDTO;
    /**
     * 
     * @type {string}
     * @memberof LayoutSettingsDTO
     */
    mode?: LayoutSettingsDTOModeEnum;
}


/**
 * @export
 */
export const LayoutSettingsDTOModeEnum = {
    Grid: 'GRID',
    Custom: 'CUSTOM'
} as const;
export type LayoutSettingsDTOModeEnum = typeof LayoutSettingsDTOModeEnum[keyof typeof LayoutSettingsDTOModeEnum];


/**
 * Check if a given object implements the LayoutSettingsDTO interface.
 */
export function instanceOfLayoutSettingsDTO(value: object): value is LayoutSettingsDTO {
    if (!('config' in value) || value['config'] === undefined) return false;
    return true;
}

export function LayoutSettingsDTOFromJSON(json: any): LayoutSettingsDTO {
    return LayoutSettingsDTOFromJSONTyped(json, false);
}

export function LayoutSettingsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayoutSettingsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'config': LayoutConfigDataDTOFromJSON(json['config']),
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function LayoutSettingsDTOToJSON(value?: LayoutSettingsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'config': LayoutConfigDataDTOToJSON(value['config']),
        'mode': value['mode'],
    };
}

